import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import * as fromActions from "./citizens-providers-summaries.actions";
import * as fromGraphql from "./citizens-providers-summaries.graphql"

@Injectable()
export class CitizensProvidersSummariesEffects {


  citizenGetProvidersSummaries$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetProvidersSummaries),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_CITIZEN_PROVIDER_SUMMARIES,
        fetchPolicy: 'network-only',
        variables:{

        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching citizen Services Citizen Group'),
        map(({ data }: any ) => {
          if (data) {
            const result: any =  data?.citizenGetProvidersSummaries
            result?.response?.status ? this.store.dispatch(fromActions.loadCitizensProvidersSummariess({ citizensProvidersSummariess: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
